import React, { useState } from "react";
import DeleteUserModal from "../../../components/modals/DeleteUserModal";

const TeacherTable = ({ teachers, deleteTeacher }) => {
  const [isDeleteModalOpened, setDeleteModalOpened] = useState(false);

  const [teacherForDeletion, setTeacherForDeletion] = useState({});

  const handleTeacherDeletionBtn = (teacher) => {
    setTeacherForDeletion(teacher);
    setDeleteModalOpened(true);
  };

  const handleTeacherDeleteModalBtn = (event) => {
    if (Object.keys(teacherForDeletion).length !== 0) {
      deleteTeacher(event, teacherForDeletion.username, setDeleteModalOpened);
    }
  };

  return (
    <>
      <div className="w-[75%] overflow-x-auto shadow-md sm:rounded-lg mt-12 self-center">
        <table className="w-full text-xl text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xl bg-[#474554] text-white uppercase">
            <tr>
              <th scope="col" className="px-6 py-3">
                GR No
              </th>
              <th scope="col" className="px-6 py-3">
                Teacher Name
              </th>
              <th scope="col" className="px-6 py-3">
                Email ID
              </th>
              <th scope="col" className="px-6 py-3">
                Department
              </th>
              <th scope="col" className="px-6 py-3">
                <span>Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {teachers.map((teacher) => (
              <tr
                key={teacher.username}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-[#333333] whitespace-nowrap"
                >
                  {teacher.username}
                </th>
                <td className="px-6 py-4 text-[#333333]">{teacher.name}</td>
                <td className="px-6 py-4 text-[#333333]">
                  {teacher.collegeEmailId}
                </td>
                <td className="px-6 py-4 text-[#333333]">
                  {teacher.department}
                </td>
                <td className="px-6 py-4">
                  <button
                    type="button"
                    data-modal-toggle="popup-modal"
                    onClick={() => handleTeacherDeletionBtn(teacher)}
                    className="block text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {teachers.length === 0 && (
        <div className="flex flex-row justify-center items-center text-5xl w-full h-[10%] py-[10%]">
          <h1>No Data Available</h1>
        </div>
      )}

      <DeleteUserModal
        title={`Are you sure you want to delete this student with GR/PR No ${teacherForDeletion.username}`}
        show={isDeleteModalOpened}
        username={teacherForDeletion.username}
        onConfirmationCallback={handleTeacherDeleteModalBtn}
        onCloseCallback={() => setDeleteModalOpened(false)}
      />
    </>
  );
};

export default TeacherTable;
